/* eslint-disable max-len */
import { cn } from '../cn';

export const IconPhone = ({ className = '' }): JSX.Element => (
  <svg role='img' className = {cn('inline', className)} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M6 4H10L12 9L9.5 10.5C10.571 12.6715 12.3285 14.429 14.5 15.5L16 13L21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21C15.0993 20.763 11.4202 19.1065 8.65683 16.3432C5.8935 13.5798 4.23705 9.90074 4 6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4Z' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
  </svg>
);
